import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/modules/admin/admin.service';
import { HelperService } from 'src/app/utils/helper.service';

@Component({
  selector: 'app-add-servidor',
  templateUrl: './add-servidor.component.html',
  styleUrls: ['./add-servidor.component.css']
})
export class AddServidorComponent implements OnInit {

  servidorForm: UntypedFormGroup;
  orgao = false;
  loading = false;

  orgaos = [];
  orgaosLoading = false;

  constructor(
    public dialogRef: MatDialogRef<AddServidorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public helper: HelperService,
    private adminService: AdminService,
    private fb: UntypedFormBuilder
  ) { }
  ngOnInit(): void {
    const cpfFormatado = this.data && this.data.cpf ? this.helper.addCPFLashes(this.data.cpf) : '';
    
    this.servidorForm = this.fb.group({
      cpf: [cpfFormatado, Validators.required],
      vinculo: [null, Validators.required],
      nome: [null, Validators.required],
      dataNascimento: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      genero: [null, Validators.required],
      origem: [null, Validators.required],
      orgaoLotacao: [null, Validators.required],
    });
    this.getOrgaoList();

    if (this.data && this.data.dadosRHNet) {
      this.preencherDadosRHNet(this.data.dadosRHNet);
    }
  }

  preencherDadosRHNet(dados: any) {
    const telefone = this.extrairTelefone(dados.telefones);
    const genero = dados.siglaSexo === 'M' ? 'MASCULINO' : dados.siglaSexo === 'F' ? 'FEMININO' : null;

    this.servidorForm.patchValue({
      nome: dados.nome || null,
      dataNascimento: dados.dataNascimento || null,
      email: dados.email || null,
      telefone: telefone || '',
      genero: genero
    });
  }

  extrairTelefone(telefones: any[]): string | null {
    if (!telefones || telefones.length === 0) {
      return null;
    }

    for (const tel of telefones) {
      if (tel.tipoTelefoneDesc === 'celular') {
        return tel.ddd + tel.numero;
      }
    }

    return telefones[0] ? telefones[0].ddd + telefones[0].numero : null;
  }
  getOrgaoList() {
    this.orgaosLoading = true;
    this.servidorForm.controls.orgaoLotacao.disable();
    this.adminService.listarOrgaos()
      .subscribe((orgaos: any[]) => {
        this.orgaos = orgaos;
        this.orgaosLoading = false;
        this.servidorForm.controls.orgaoLotacao.enable();
      },
        error => {
          console.error(error);
          this.orgaosLoading = false;
          this.servidorForm.controls.orgaoLotacao.enable();
        });
  }

  closeDialog() {
    const cpf = (this.data?.cpf || this.servidorForm.value.cpf || '')
      .toString()
      .replace(/\D/g, '');
    const telefone = (this.servidorForm.value.telefone || '')
      .toString()
      .replace(/\D/g, '');
    const orgaoLotacao = this.servidorForm.getRawValue().orgaoLotacao;

    this.dialogRef.close({
      cpf,
      nome: this.servidorForm.value.nome,
      dataNascimento: this.helper.formatarData(this.servidorForm.value.dataNascimento),
      email: this.servidorForm.value.email,
      telefone,
      genero: this.servidorForm.value.genero,
      vinculo: {
        tipo: this.servidorForm.value.vinculo,
        orgaoLotacaoId: orgaoLotacao?.id,
        origemNome: this.servidorForm.value.origem,
      }
    });
  }
  compareWithOrgao(o1: any, o2: any) {
    return o1?.id === o2?.id;
  }
}
